export default __webpack_public_path__ + "static/media/small_balancing_tube_st.1cd1637e.svg";